<template>
  <div class="class-book-wrap">
    <a-card>
      <s-table
        :columns="columns"
        :data="loadData"
        :scroll="{ x:1280 }"
        class="scroll-table-wrap"
        ref="table"
        rowKey="id"
        size="default"
      >
        <span slot="courseDateRange" slot-scope="text, record">
          {{ record.startDate }}~{{ record.finishDate }}
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="showBookModal(record)">通讯录</a>
        </span>
      </s-table>
      <class-book-modal ref="classBookModal"/>
    </a-card>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import STable from '@/components/table/'
  import classBook from '../../api/classBook'
  import ClassBookModal from './ClassBookModal'

  export default {
    name: 'classBook',
    components: {
      STable,
      ClassBookModal
    },
    data() {
      return {
        parameters: {},
        columns: [
          {
            title: '课程日期',
            dataIndex: 'testPaperName',
            className: 'min-wid-m',
            scopedSlots: { customRender: 'courseDateRange' }
          },
          {
            title: '班级',
            dataIndex: 'className',
            className: 'min-wid-s',
            ellipsis: true
          },
          {
            title: '班主任',
            dataIndex: 'headmaster',
            className: 'min-wid-s',
            ellipsis: true
          },
          {
            title: '操作',
            dataIndex: 'action',
            className: 'min-wid-s',
            scopedSlots: { customRender: 'action' }
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          const transferQuery = {}
          const order = parameter.sortOrder !== undefined ? parameter.sortOrder.substring(0, parameter.sortOrder.length - 3) : ''
          const page = {
            pageNo: parameter.pageNo,
            pageSize: parameter.pageSize,
            sortField: parameter.sortField,
            draw: order
          }
          return classBook.classList(Object.assign(transferQuery, page))
        }
      }
    },
    computed: {
      ...mapState({
        userData: state => {
          if (state.user.userData.name) {
            return state.user.userData
          } else {
            return JSON.parse(localStorage.getItem('user'))
          }
        }
      })
    },
    filters: {},
    methods: {
      showBookModal(record) {
        this.$refs.classBookModal.show(record)
      }
    }

  }
</script>
<style lang="less">
  .class-book-wrap {
  }
</style>
